// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/_css-loader@3.4.2@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** 可以写通用样式（也可以在vnode中写） */\nbody {\n  padding: 0;\n  margin: 0;\n}\n", ""]);
// Exports
module.exports = exports;
